"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["mat-row[_ngcontent-%COMP%]{cursor:default}mat-row[_ngcontent-%COMP%]:hover{opacity:.75}.details[_ngcontent-%COMP%]{margin:25px 0;width:500px;font-size:20px}"];
exports.styles = styles;
